export default {"src":"/_next/static/image/src/components/FactsTable/ollie_icon.014d5e7858d80ab5da85391f260837a4.svg","height":25,"width":50};